//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            bankAccount: null,
            bankAccounts: [],
            reconcile: {
                system_account_balance: 0.00,
                bank_account_balance: 0.00,
                period: moment(),
                statement_date: moment().format("MM/DD/YYYY")
            },
            selectedAccountTransaction: null,
            selectedBankTransaction: null,
            accountsLoading: false,
            accountTransactions: [],
            bankLoading: false,
            bankTransactions: [],
            reconcileTransactionTotal: 0.00,
            bankTransactionItemTotal: 0.00,
            bankTransactionItemSelectedIndexes: [],
            bankTransactionItemSelected: [],
            accountTransactionItemTotal: 0.00,
            accountTransactionItemSelectedIndexes: [],
            accountTransactionItemSelected: [],
            matchedBankTransactions: [],
            matchedAccountTransactions: [],
            is_complete: false,
            bankTransactionManual: false,
            showManualTransactionMatch: false,
            matchedSystemTransactionList: [],
            startMatchTransactions: false,
            saving: false,
            newMatchTransactions: false,
            unReconciledTransactions: false
        };
    },


    methods: {
        close: function close() {
            Event.$emit('close-full-modal');
        },
        addAdjustment: function addAdjustment() {
            Event.$emit('add-manual-bank-reconcile-adjustment', this.reconcile.id);

            // reset
            this.bankTransactionItemSelectedIndexes = [];
            this.bankTransactionItemSelected = [];
            this.accountTransactionItemSelectedIndexes = [];
            this.accountTransactionItemSelected = [];
            this.selectedAccountTransaction = null;
            this.selectedBankTransaction = null;
            this.accountTransactionItemTotal = 0.00;
            this.bankTransactionItemTotal = 0.00;
            this.startMatchTransactions = false;
        },
        importManualTransactions: function importManualTransactions() {
            var _this = this;

            if (!this.bankAccount || !this.bankAccount.id) {
                this.$snotify.error('You must slected a bank account...');
            } else {
                axios.post('/prototype/accounting/general-ledger/reconcile/store', this.$data).then(function (response) {
                    _this.reconcile.id = response.data.id;
                    Event.$emit('import-manual-transactions', response.data.id);
                });
            }
        },
        loadManualTransactions: function loadManualTransactions(reconcile) {
            var _this2 = this;

            this.reconcile.bank_account_balance = reconcile.bank_account_balance;
            this.bankLoading = true;
            axios.post('/prototype/accounting/general-ledger/reconcile/manual-entries', {
                id: this.reconcile.id,
                bank_reconcile_id: this.reconcile.bank_account_id,
                period: this.reconcile.period
            }).then(function (response) {
                _this2.bankTransactions = response.data;
                _this2.bankTransactions.map(function (item) {
                    return item.amount = Number.parseFloat(item.amount).toFixed(2);
                });
                _this2.bankLoading = false;
            });
        },
        removeUnreconciled: function removeUnreconciled(reconcile) {
            var _this3 = this;

            this.bankLoading = true;
            axios.delete('/prototype/accounting/general-ledger/reconcile/manual-reconcile-transactions/' + this.reconcile.bank_account_id).then(function (response) {
                _this3.loadManualTransactions(reconcile);
            });
        },
        matchTransactions: function matchTransactions() {
            var _this4 = this;

            this.newMatchTransactions = true;
            // create unique ID for match
            var match_id = Date.now();

            this.accountTransactionItemSelectedIndexes.map(function (id) {
                return _this4.matchedAccountTransactions.push({
                    'id': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).id,
                    'type': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).model,
                    'model_id': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).model_id,
                    'match': match_id,
                    'amount': _this4.getAmount(_this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    })),
                    'date': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).date,
                    'accounting_type': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).type,
                    'description': _this4.unmatchedAccountTransactions.find(function (account) {
                        return account.id === id;
                    }).description
                });
            });

            this.bankTransactionItemSelectedIndexes.map(function (id) {
                return _this4.matchedBankTransactions.push({
                    'id': _this4.unmatchedBankTransactions.find(function (account) {
                        return account.transaction_id === id;
                    }).transaction_id,
                    'type': 'App\\ManualBankReconcileTransactions',
                    'model_id': _this4.unmatchedBankTransactions.find(function (account) {
                        return account.transaction_id === id;
                    }).id,
                    'match': match_id,
                    'amount': _this4.unmatchedBankTransactions.find(function (account) {
                        return account.transaction_id === id;
                    }).amount,
                    'date': _this4.unmatchedBankTransactions.find(function (account) {
                        return account.transaction_id === id;
                    }).date,
                    'description': _this4.unmatchedBankTransactions.find(function (account) {
                        return account.transaction_id === id;
                    }).description
                });
            });

            // reset
            this.bankTransactionItemSelectedIndexes = [];
            this.bankTransactionItemSelected = [];
            this.accountTransactionItemSelectedIndexes = [];
            this.accountTransactionItemSelected = [];
            this.selectedAccountTransaction = null;
            this.selectedBankTransaction = null;
            this.accountTransactionItemTotal = 0.00;
            this.bankTransactionItemTotal = 0.00;
            this.startMatchTransactions = false;
        },
        cancelMatchTransactions: function cancelMatchTransactions() {

            this.startMatchTransactions = false;
            this.bankTransactionItemSelectedIndexes = [];
            this.bankTransactionItemSelected = [];
            this.accountTransactionItemSelectedIndexes = [];
            this.accountTransactionItemSelected = [];
            this.accountTransactionItemTotal = 0.00;
            this.bankTransactionItemTotal = 0.00;
        },
        saveMatchedSystemTransactions: function saveMatchedSystemTransactions() {
            var _this5 = this;

            // create unique ID for match
            var match_id = Date.now();

            this.matchedSystemTransactionList.map(function (transaction) {
                return _this5.matchedAccountTransactions.push({
                    'id': transaction.id,
                    'type': transaction.model,
                    'model_id': transaction.model_id,
                    'match': match_id,
                    'amount': _this5.getAmount(transaction),
                    'date': transaction.date,
                    'accounting_type': transaction.type,
                    'description': transaction.description
                });
            });

            // reset
            this.matchedSystemTransactionList = [];
        },
        closeSelectedTransactions: function closeSelectedTransactions() {
            this.bankTransactionItemSelectedIndexes = [];
            this.bankTransactionItemSelected = [];
            this.accountTransactionItemSelectedIndexes = [];
            this.accountTransactionItemSelected = [];
            this.selectedAccountTransaction = null;
            this.selectedBankTransaction = null;
            this.accountTransactionItemTotal = 0.00;
            this.bankTransactionItemTotal = 0.00;
        },
        resetAccountTransaction: function resetAccountTransaction(item, idx) {
            var _this6 = this;

            this.unReconciledTransactions = true;
            var match_id = item.match;

            this.matchedAccountTransactions.map(function (account, idx) {
                if (account.match === match_id) {
                    _this6.accountTransactions.push(account);
                }
            });

            this.matchedAccountTransactions = this.matchedAccountTransactions.filter(function (account) {
                return account.match !== match_id;
            });

            this.matchedBankTransactions.map(function (account, idx) {
                if (account.match === match_id) {
                    //this.bankTransactions.push(account)
                }
            });

            this.matchedBankTransactions = this.matchedBankTransactions.filter(function (account) {
                return account.match !== match_id;
            });
        },
        chooseAccountTransaction: function chooseAccountTransaction(item, idx) {

            if (this.startMatchTransactions) {

                var canMatchMultiple = true;
                var canMatch = true;

                //if(this.accountTransactionItemSelected.find(item => item.type != 'credit' && item.type != 'debit')) {
                //    canMatchMultiple = false
                //}

                if (!canMatchMultiple) {
                    if (this.accountTransactionItemSelectedIndexes.length >= 2 || this.bankTransactionItemSelectedIndexes.length >= 1) {
                        canMatch = false;
                    }
                }

                if (!this.accountTransactionItemSelectedIndexes.find(function (id) {
                    return id === item.id;
                })) {
                    if (canMatch) {
                        this.accountTransactionItemSelectedIndexes.push(item.id);
                        this.accountTransactionItemSelected.push(item);
                        item.type == 'credit' || item.type == 'adjustment-negative' ? this.accountTransactionItemTotal -= +Number(item.amount).toFixed(2) : this.accountTransactionItemTotal += +Number(item.amount).toFixed(2);
                    }
                } else {
                    var _idx = this.accountTransactionItemSelectedIndexes.findIndex(function (id) {
                        return id === item.id;
                    });
                    if (_idx >= 0) {
                        this.accountTransactionItemSelected.splice(_idx, 1);
                        this.accountTransactionItemSelectedIndexes.splice(_idx, 1);
                        item.type == 'credit' || item.type == 'adjustment-negative' ? this.accountTransactionItemTotal += +Number(item.amount).toFixed(2) : this.accountTransactionItemTotal -= +Number(item.amount).toFixed(2);
                    }
                }
            }
        },
        chooseBankTransaction: function chooseBankTransaction(item, idx) {

            if (this.startMatchTransactions) {

                var canMatchMultiple = true;
                var canMatch = true;

                //if(this.accountTransactionItemSelected.find(item => item.type != 'credit' && item.type != 'debit')) {
                //    canMatchMultiple = false
                //}

                if (!canMatchMultiple) {
                    if (this.accountTransactionItemSelectedIndexes.length >= 2 || this.bankTransactionItemSelectedIndexes.length >= 1) {
                        canMatch = false;
                    }
                }

                if (!this.bankTransactionItemSelectedIndexes.find(function (id) {
                    return id === item.transaction_id;
                })) {
                    if (canMatch) {
                        this.bankTransactionItemSelectedIndexes.push(item.transaction_id);
                        this.bankTransactionItemSelected.push(item);
                        this.bankTransactionItemTotal = (parseFloat(this.bankTransactionItemTotal) + parseFloat(item.amount)).toFixed(2);
                    }
                } else {
                    var _idx2 = this.bankTransactionItemSelectedIndexes.findIndex(function (id) {
                        return id === item.transaction_id;
                    });
                    if (_idx2 >= 0) {
                        this.bankTransactionItemSelected.splice(_idx2, 1);
                        this.bankTransactionItemSelectedIndexes.splice(_idx2, 1);
                        this.bankTransactionItemTotal = (parseFloat(this.bankTransactionItemTotal) - parseFloat(item.amount)).toFixed(2);
                    }
                }
            }
        },
        checkBankItemSelected: function checkBankItemSelected(item) {
            return this.bankTransactionItemSelectedIndexes.includes(item.transaction_id);
        },
        checkAccountItemSelected: function checkAccountItemSelected(item) {
            if (this.showManualTransactionMatch) {
                return this.matchedSystemTransactionList.find(function (transaction) {
                    return transaction.id === item.id;
                });
            } else {
                return this.accountTransactionItemSelectedIndexes.includes(item.id);
            }
        },
        getType: function getType(item) {
            return item.type;
        },
        getExplanatoryType: function getExplanatoryType(item) {
            if (item.accounting_type == 'debit') {
                return 'Deposit';
            }
            if (item.accounting_type == 'credit') {
                return 'Withdrawal';
            }
            if (item.accounting_type == 'adjustment-positive' || item.accounting_type == 'adjustment-negative') {
                return 'Adjustment';
            }
            return 'Unknown';
        },
        getAmount: function getAmount(item) {
            return item.type == 'debit' ? item.amount : -item.amount;
        },
        save: function save() {
            this.$data.reconcile.difference = this.reconcileDifference;
            axios.post('/prototype/accounting/general-ledger/reconcile/store', this.$data).then(function (response) {
                Event.$emit('refresh-bank-reconciles');
                Event.$emit('close-full-modal');
            });
        },
        finalize: function finalize() {
            var _this7 = this;

            this.$data.reconcile.difference = this.reconcileDifference;
            this.saving = true;
            this.is_complete = true;
            axios.post('/prototype/accounting/general-ledger/reconcile/store', this.$data).then(function (response) {
                Event.$emit('refresh-bank-reconciles');
                Event.$emit('close-full-modal');
                _this7.saving = false;
            });
        },
        refreshData: function refreshData() {
            Event.$emit('refresh-data');
        },
        resetCache: function resetCache() {
            Event.$emit('refresh-data', true);
        },
        deleteBankRec: function deleteBankRec() {
            Event.$emit('confirm-delete', this.reconcile, '/prototype/accounting/general-ledger/reconcile/destroy', 'bank-rec-removed');
        }
    },

    computed: {
        userCanDelete: function userCanDelete() {
            return window.user.role == 'super-admin' || window.user.id.includes('andrew@maderaresidential.com') || window.user.id.includes('krendon@maderaresidential.com');
        },
        reconcileDifference: function reconcileDifference() {
            if (this.reconcile.status !== 'Complete') {
                return Number(this.reconcile.bank_account_balance) - Number(this.reconcile.system_account_balance) - (Number(this.unmatchedAccountTransactionsTotal) + Number(this.unmatchedBankTransactionsTotal));
            } else {
                return this.reconcile.difference;
            }
        },
        transactionsTrueEqual: function transactionsTrueEqual() {
            return Number(Math.round(this.accountTransactionItemTotal)) === Number(Math.round(this.bankTransactionItemTotal));
        },
        unmatchedAccountTransactions: function unmatchedAccountTransactions() {
            var _this8 = this;

            return this.accountTransactions.filter(function (account) {
                return !_this8.matchedAccountTransactions.find(function (item) {
                    return item.model_id === account.model_id && item.type == account.model && item.accounting_type == account.type;
                });
            });
        },
        unmatchedBankTransactions: function unmatchedBankTransactions() {
            var _this9 = this;

            return this.bankTransactions.filter(function (account) {
                return !_this9.matchedBankTransactions.find(function (item) {
                    return item.model_id === account.model_id && account.model == 'App\\ManualBankReconcileTransactions';
                });
            });
        },
        matchedAccountTransactionList: function matchedAccountTransactionList() {
            /*if(this.reconcile.status !== 'Complete') {
                return this.accountTransactions.filter((account) => {
                    return this.matchedAccountTransactions.find(item => {
                        return item.model_id === account.model_id &&
                        item.type == account.model &&
                        item.accounting_type == account.type
                    })
                })
            } else {
            */
            return this.matchedAccountTransactions;
            // }
        },
        matchedBankTransactionList: function matchedBankTransactionList() {
            /*if(this.reconcile.status !== 'Complete') {
                return this.bankTransactions.filter((account) => {
                    return this.matchedBankTransactions.find(item => {
                        return item.model_id === account.model_id &&
                        account.model == 'App\\ManualBankReconcileTransactions'
                    })
                })
            } else {
            */
            return this.matchedBankTransactions;
            //}
        },
        matchedAccountTransactionsTotal: function matchedAccountTransactionsTotal() {
            return Number.parseFloat(this.matchedAccountTransactionList.reduce(function (prev, cur) {
                return cur.type == 'debit' || cur.type == 'adjustment-negative' ? Number(prev) + Number(cur.amount) : Number(prev) - Number(cur.amount);
            }, 0)).toFixed(2);
        },
        matchedSystemWithdrawalsTotal: function matchedSystemWithdrawalsTotal() {
            return Number.parseFloat(this.matchedSystemTransactionList.reduce(function (prev, cur) {
                return cur.type == 'debit' || cur.type == 'adjustment-negative' ? Number(prev) + Number(cur.amount) : Number(prev) + 0;
            }, 0)).toFixed(2);
        },
        matchedSystemDepositsTotal: function matchedSystemDepositsTotal() {
            return Number.parseFloat(this.matchedSystemTransactionList.reduce(function (prev, cur) {
                return cur.type == 'credit' || cur.type == 'adjustment-positive' ? Number(prev) + Number(cur.amount) : Number(prev) + 0;
            }, 0)).toFixed(2);
        },
        unmatchedAccountTransactionsTotal: function unmatchedAccountTransactionsTotal() {
            return Number.parseFloat(this.unmatchedAccountTransactions.reduce(function (prev, cur) {
                return cur.type == 'debit' || cur.type == 'adjustment-negative' ? Number(prev) - Number(cur.amount) : Number(prev) + Number(cur.amount);
            }, 0)).toFixed(2);
        },
        unmatchedBankTransactionsTotal: function unmatchedBankTransactionsTotal() {
            return Number.parseFloat(this.unmatchedBankTransactions.reduce(function (prev, cur) {
                return Number(prev) + Number(cur.amount);
            }, 0)).toFixed(2);
        }
    },

    watch: {
        bankAccount: function bankAccount(account) {
            Event.$emit('refresh-data');
        }
    },

    mounted: function mounted() {
        var _this10 = this;

        var $el = this;

        Event.$on('bank-rec-removed', function () {
            Event.$emit('refresh-bank-reconciles');
            Event.$emit('close-full-modal');
        });

        Event.$on('refresh-manual-transactions', function (reconcile) {
            return _this10.loadManualTransactions(reconcile);
        });

        Event.$on('refresh-data', function () {
            var resetCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


            if (_this10.bankAccount) {

                if (_this10.reconcile.id || resetCache) {

                    // clear transactions
                    _this10.accountTransactions = [];

                    // load journal entries
                    _this10.accountsLoading = true;
                    axios.post('/prototype/accounting/general-ledger/accounts/reconcile-entries', { id: _this10.bankAccount.gl_account_id, reconcile: _this10.reconcile.id, period: _this10.reconcile.period, refresh: resetCache }).then(function (response) {
                        _this10.reconcile.system_account_balance = response.data.balance;
                        _this10.accountTransactions = response.data.results;
                        _this10.accountsLoading = false;
                    });

                    // load transactions from Plaid
                    if (_this10.bankAccount.account_id != 0) {

                        _this10.bankLoading = true;
                        axios.post('/prototype/accounting/general-ledger/reconcile/entries', { token: _this10.bankAccount.access_token, account: _this10.bankAccount.account_id }).then(function (response) {
                            _this10.bankTransactions = response.data.transactions;
                            _this10.bankLoading = false;
                        });
                    }

                    if (_this10.bankAccount.account_id == 0) {
                        _this10.bankTransactionManual = true;
                        _this10.loadManualTransactions(_this10.reconcile);
                    }
                }
            } else {
                Object.assign(_this10.$data, _this10.$options.data());
            }
        });

        Event.$on('add-bank-reconcile', function () {
            Object.assign(_this10.$data, _this10.$options.data());
            $el.$children[0].$data.showModal = true;

            // reset
            _this10.bankAccount = false;
            Event.$emit('refresh-data');

            axios.get('/prototype/accounting/check-writing-bank-accounts').then(function (response) {
                return _this10.bankAccounts = response.data;
            });
        });

        Event.$on('update-bank-reconcile', function (id) {
            Object.assign(_this10.$data, _this10.$options.data());
            $el.$children[0].$data.showModal = true;
            axios.get('/prototype/accounting/check-writing-bank-accounts').then(function (response) {
                return _this10.bankAccounts = response.data;
            });
            axios.post('/prototype/accounting/general-ledger/reconcile/fetch', { id: id }).then(function (response) {
                _this10.reconcile = response.data;
                _this10.reconcile.transactions.map(function (transaction) {
                    if (transaction.transactionable_type != 'App\\ManualBankReconcileTransactions') {
                        _this10.matchedAccountTransactions.push({
                            'id': transaction.id,
                            'date': transaction.transactionable_date,
                            'model_id': transaction.transactionable_id,
                            'type': transaction.transactionable_type,
                            'match': transaction.match_id,
                            'amount': transaction.amount,
                            'accounting_type': transaction.accounting_type,
                            'description': transaction.description
                        });
                    } else {
                        _this10.matchedBankTransactions.push({
                            'id': transaction.plaid_transaction_id,
                            'date': transaction.transactionable_date,
                            'model_id': transaction.transactionable_id,
                            'type': transaction.transactionable_type,
                            'match': transaction.match_id,
                            'amount': transaction.amount,
                            'description': transaction.description
                        });
                    }
                });
                _this10.bankAccount = _this10.reconcile.bank_account;
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reconcile/AddBankReconcile.vue
// module id = H0E6
// module chunks = 0 1